const SET_MULTI_LOADER = 'SET_MULTI_LOADER';
const RESET_MULTI_LOADER = 'RESET_MULTI_LOADER';

export {
    SET_MULTI_LOADER,
    RESET_MULTI_LOADER,
}